import { FormulaManager } from '@utils/managers/FormulaManager';
import { areAllDisplayValuesEmpty } from '@utils/documentUtils';
import React from 'react';

export const handlerFieldWatch = async (
    watch: any[],
    isEdit: boolean,
    isNew: boolean,
    manager: FormulaManager,
    setMethod: (value: React.SetStateAction<boolean>) => void,
    isActivatedComponent: React.RefObject<boolean>,
    onEvaluated?: (result: unknown) => void,
) => {
    let result = true;
    if (watch.length != 0) {
        if (!watch.every((element) => element === undefined)) {
            result = await manager.EvalFormulaValues(isEdit, isNew, watch);
            onEvaluated?.(result);
            if (isActivatedComponent.current) setMethod(result);
        }
    } else {
        result = await manager.EvalFormulaValues(isEdit, isNew);
        onEvaluated?.(result);
        if (isActivatedComponent.current) setMethod(result);
    }
    return result;
};
export const handlerFieldReplaceWatch = async (
    watch: any[],
    isEdit: boolean,
    isNew: boolean,
    manager: FormulaManager,
    setMethod: (value: React.SetStateAction<any | undefined>) => void,
    onEvaluated?: (result: unknown) => void,
) => {
    if (watch.length != 0) {
        if (!watch.every((element) => element === undefined)) {
            let coll: any[] = [];
            watch.forEach((x) => {
                if (x === null) {
                    coll.push('');
                } else {
                    coll.push(x);
                }
            });
            let d = await manager.ReplaceFormulaValues(isEdit, isNew, coll, false);
            onEvaluated?.(d);

            if (d) {
                setMethod(d);
            }
        }
    }
};

export interface IWatchHandlerResult {
    watch: any[];
    result: any;
}

export const handlerFieldDisplayWatch = async (
    watch: any[],
    isEdit: boolean,
    isNew: boolean,
    manager: FormulaManager,
    evalDisplayFormat: boolean = false,
    /** Считать формулу и когда все зависимые поля пусты (см. useFormulaDisplay). */
    evaluateOnEmpty: boolean = false,
) => {
    if (watch.length != 0) {
        if (!evaluateOnEmpty && areAllDisplayValuesEmpty(watch)) {
            return {
                watch: watch,
                result: '',
            } as IWatchHandlerResult;
        }

        if (!watch.every((element) => element === undefined)) {
            let result = await manager.ReplaceFormulaValues(isEdit, isNew, watch, !evalDisplayFormat);

            return {
                watch: watch,
                result: result ? result : '',
            } as IWatchHandlerResult;
        }
    }
    return null;
};
